export default __webpack_public_path__ + "static/pc_owner-576d61a289eb6a1cfa79e7f23d91bec2.jpg";